import { Directive, HostBinding, HostListener, OnInit } from '@angular/core';

@Directive({
  selector: 'div[csLeftPanel]',
  standalone: false
})
export class LeftPanelDirective implements OnInit {
  @HostBinding('class.cs-left-panel')
  public class = true;
  @HostBinding('style.height.px')
  public containerHeight: number;

  public ngOnInit(): void {
    this.containerHeight = window.innerHeight - 62;
  }

  @HostListener('window.resize')
  public onResize(): void {
    this.containerHeight = window.innerHeight - 62;
  }
}
